// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import type { Node } from 'react'
import ErrorText from '../../controls/ErrorText'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  position: relative;
  width: 100%;
`
const HeaderWrapper: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  vertical-align: top;
  padding-bottom: 4px;
`

type Props = {|
  header: Node,
  input: Node,
  errors?: Array<string>,
  className?: string
|}

export default class LabeledInput extends Component<Props> {
  render() {
    const { header, input, errors, className } = this.props

    return (
      <Wrapper className={className}>
        <HeaderWrapper>{header}</HeaderWrapper>
        <div>{input}</div>
        <ErrorText errors={errors} />
      </Wrapper>
    )
  }
}
